import {DataTransferObject} from './DataTransferObject';
import {Model, Order} from '../Models';
import {LocalStorageObject} from '../Utilities';

export class CartDTO extends DataTransferObject implements LocalStorageObject {
  public order!: Order;
  public errors!: Array<any>;
  public sum!: number;
  public vatSum!: number;
  public advertised!: Array<AdvertisedProduct>;
  public promotedProducts!: Array<PromotedProduct>;
  public cartPromotions!: Array<CartPromotion>;
  public failedSlotUpdates!: Array<any>;
  // key: eventId, cart promotions are applied per event, amount is in cents (100 = 1€)
  public cartPromotionSums!: CartPromotionSums;

  constructor(data: any = null) {
    super();
    if (data !== null) {
      return this.fromData(data);
    }
  }

  fromStorage(data: any) {
    return this.fromData(data);
  }

  fromModel(model: Model): CartDTO {
    return new CartDTO();
  }

  fromData(data: any): CartDTO {
    const cart = new CartDTO();
    cart.advertised = data.advertised || [];
    cart.order = new Order(data.order);
    cart.errors = data.errors || [];
    cart.sum = data.sum || 0;
    cart.vatSum = data.vatSum || 0;
    cart.promotedProducts = data.promotedProducts || [];
    cart.cartPromotions = data.cartPromotions || [];
    cart.failedSlotUpdates = data.failedSlotUpdates || [];
    const cartPromoSums = data.cartPromotionSums || {};
    cart.cartPromotionSums = Array.isArray(cartPromoSums) ? {} : cartPromoSums;
    return cart;
  }
}
